import { useEffect, useRef, useState } from "react";

export default function ToastListener() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      setToast(e.detail);

      // clear timer cũ (nếu spam toast)
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        setToast(null);
      }, 3000);
    };

    window.addEventListener("showNotification", handler);
    return () => {
      window.removeEventListener("showNotification", handler);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (!toast) return null;

  return (
   <div className="notification ">
      <div className="notification-content notification-error">
        <span className="notification-message">{toast.message}</span>
        <button
          className="notification-close"
          onClick={() => {
            if (timerRef.current) clearTimeout(timerRef.current);
              setToast(null);
            }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
